module.exports = __webpack_public_path__ + "img/address.996a36fa.png";